import { descriviCosto, percento, totaliPerValuta } from './Functions'
import { t } from './testi'

/**
 * Le quattro card in testata: costo, run, prove classificate (verde/rosso in vista) e
 * analisi degli scenari in difficoltà. `testata` assente = numeri ancora da caricare.
 * @param {Object} props - Proprietà
 * @param {Object|undefined} props.testata - La testata del server
 * @param {Object} props.misure - `misureTestata(testata)`
 * @param {Array<Object>} props.costi - Il costo del periodo
 * @param {Object} props.difficolta - L'analisi dei scenari in difficoltà
 * @param {number} props.numeroRun - Le run lette (solo se manca la testata)
 * @param {string|null} props.runInCorso - L'id della run in corso
 * @param {number} props.inCoda - Le run in coda
 * @param {() => void} props.onCosto - Apre il dettaglio dei costi
 * @param {() => void} props.onAnalisi - Apre l'analisi
 */
export const CardRiepilogo = ({
  testata,
  misure,
  costi,
  difficolta,
  numeroRun,
  runInCorso,
  inCoda,
  onCosto,
  onAnalisi
}) => (
  <div className="ae-testata">
    <div className="ncard nkpi-card nkpi-card--green">
      <div className="ncard__body">
        <div className="nkpi__label">{t.aeProveClassificate}</div>
        <div className="nkpi__value ae-kpi__valore">
          {testata ? misure.verdi + misure.rossi + misure.errori + misure.nonValidi : '—'}
        </div>
        {testata ? (
          <div className="ae-kpi-esiti">
            <span className="is-ok">
              <strong>{misure.verdi}</strong> {t.aeColVerdi.toLowerCase()}
            </span>
            <span className={misure.rossi ? 'is-ko' : ''}>
              <strong>{misure.rossi}</strong> {t.aeColRossi.toLowerCase()}
            </span>
            <span>
              <strong>{misure.errori}</strong> {t.aeColErrori.toLowerCase()}
            </span>
            <span>
              <strong>{misure.nonValidi}</strong> {t.aeColNonValidi.toLowerCase()}
            </span>
            <span>
              <strong>{misure.saltati}</strong> {t.aeProveSaltate}
            </span>
            {misure.nonClassificati ? (
              <span>
                <strong>{misure.nonClassificati}</strong> {t.aeNonClassificati}
              </span>
            ) : null}
          </div>
        ) : (
          <div className="nkpi__foot">{t.aeCostoTotaleSotto}</div>
        )}
      </div>
    </div>
    <div className="ncard nkpi-card ae-kpi--difficolta">
      <div className="ncard__body">
        <div className="nkpi__label">{t.aeAnalisi}</div>
        <div className={`nkpi__value ae-kpi__valore ${difficolta.sotto ? 'is-ko' : ''}`}>
          {difficolta.sotto}
        </div>
        <div className="nkpi__foot">
          {percento(difficolta.fallite, difficolta.prove)} {t.aeProveFallite}
          {' · '}
          {difficolta.scenari} {t.aeScenariEseguiti}
        </div>
        <button type="button" className="nbtn nbtn--ghost nbtn--sm" onClick={onAnalisi}>
          {t.aeApriDettaglio}
        </button>
      </div>
    </div>
    <div className="ncard nkpi-card">
      <div className="ncard__body">
        <div className="nkpi__label">{t.aeRun}</div>
        <div className="nkpi__value ae-kpi__valore">{testata ? misure.run : numeroRun}</div>
        <div className="nkpi__foot">
          {testata
            ? `${percento(misure.perStato.completata ?? 0, misure.run)} ${t.aeCompletata} · ${percento(
                misure.perStato.fermata ?? 0,
                misure.run
              )} ${t.aeFermata} · ${percento(misure.perStato.fallita ?? 0, misure.run)} ${t.aeFallita}`
            : t.aeNessunaInCorso}
        </div>
        <div className="nkpi__foot">
          {runInCorso ? t.aeRunInCorso : t.aeNessunaInCorso}
          {inCoda ? ` · ${inCoda} ${t.aeInCoda}` : ''}
        </div>
      </div>
    </div>
    <div className="ncard nkpi-card nkpi-card--blue">
      <div className="ncard__body">
        <div className="nkpi__label">{t.aeCostoTotale}</div>
        <div className="nkpi__value ae-kpi__valore">
          {costi.length ? descriviCosto(totaliPerValuta(costi)) : '—'}
        </div>
        {costi.length ? (
          <button type="button" className="nbtn nbtn--ghost nbtn--sm" onClick={onCosto}>
            {t.aeCostoDettaglio}
          </button>
        ) : null}
        <div className="nkpi__foot">
          {testata && costi.length
            ? `${t.aePerRun} ${descriviCosto(misure.costoPerRun) || '—'} · ${t.aePerPasso} ${
                descriviCosto(misure.costoPerPasso) || '—'
              }`
            : t.aeCostoTotaleSotto}
        </div>
      </div>
    </div>
  </div>
)
